/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoBooleanToggle implements angular.IDirective {
        private window: angular.IWindowService;
        restrict = "A";
        scope = {
            bool: "=",
            event: "@toggleEvent"
        }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            scope.$on(scope.event, function (evt, data) {
                    //console.log(data);
                    scope.bool = data.expanded;
            });
        }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoBooleanToggle();
            };
            
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoBooleanToggle", MeevoBooleanToggle.factory());
}